import { Modal } from 'antd';
import './AntModalLayout.scss';

const AntModalLayout = ({ ModalTitle, isModalVisible, handleCancel, AntModalFrom }) => {

    return (
        <Modal
            title={ModalTitle}
            visible={isModalVisible}
            closable={false}
            className="mainAntModalLayout"
            footer={[
                <button
                    key="submit"
                    type="primary"
                    className="btn btn-outline-danger"
                    onClick={handleCancel}
                >
                    Close
                </button>
            ]}
        >
            {AntModalFrom}
        </Modal>
    );
};

export default AntModalLayout;